/* import __COLOCATED_TEMPLATE__ from './synced-source-bulk-row-actions.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';
import type SyncSourceWrapper from 'embercom/models/knowledge-hub/sync-source-wrapper';
import { isPresent } from '@ember/utils';
import type KnowledgeHubContentWrapper from 'embercom/models/content-service/knowledge-hub-content-wrapper';
import { type KnowledgeHubTableRow } from 'embercom/models/content-service/knowledge-hub-content-wrapper';

interface Args {
  tableRow: KnowledgeHubTableRow;
}

export default class SyncedSourceBulkRowActions extends Component<Args> {
  get canShowSourceRowActions(): boolean {
    return isPresent(this.syncSource);
  }

  get syncSource(): SyncSourceWrapper | undefined {
    return (this.args.tableRow as KnowledgeHubContentWrapper).syncSource;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::Table::Cells::SyncedSourceBulkRowActions': typeof SyncedSourceBulkRowActions;
    'knowledge-hub/filterable-list/table/cells/synced-source-bulk-row-actions': typeof SyncedSourceBulkRowActions;
  }
}
